import { PureComponent } from 'react';
import { func, string, oneOfType } from 'prop-types';
import { connect } from 'react-redux';

import { setHeadlineTitle } from '../../ocab-services/services.actions';
import { appointmentDraftSelectors, bookingsSelectors } from '~/api';
import { envConfigSelectors } from '../configuration';

export const withHeadlineTitle = (staticHeadlineTitle) => (Component) =>
  class ComponentWithHeadlineTitle extends PureComponent {
    static propTypes = {
      headlineTitle: oneOfType([string, func]),
      appointmentTypeName: string,

      dispatchSetHeadlineTitle: func.isRequired,
    };

    static defaultProps = {
      headlineTitle: undefined,
      appointmentTypeName: undefined,
    };

    componentDidMount() {
      this.setHeadlineTitle();
    }

    componentDidUpdate(prevProps) {
      if (this.isHeadlineTitleChanged(prevProps, this.props)) {
        this.setHeadlineTitle();
      }
    }

    isHeadlineTitleChanged = (prevProps, currentProps) =>
      prevProps.headlineTitle !== currentProps.headlineTitle;

    setHeadlineTitle = () => {
      const { headlineTitle, appointmentTypeName, dispatchSetHeadlineTitle } = this.props;

      const nextHeadlineTitle = this.isFunction(staticHeadlineTitle)
        ? staticHeadlineTitle({ headlineTitle, appointmentTypeName })
        : staticHeadlineTitle;

      dispatchSetHeadlineTitle(nextHeadlineTitle);
    };

    isFunction = (val) => typeof val === 'function';

    render() {
      return <Component {...this.props} />;
    }
  };

export const mapStateToProps = (state) => {
  const draftAppointmentTypeId = appointmentDraftSelectors.selectAppointmentTypeId(state);
  const bookingAppointmentTypeId = bookingsSelectors.selectAppointmentTypeId(state);
  const draftAppointmentTypeName = appointmentDraftSelectors.selectAppointmentTypeName(state);
  const bookingAppointmentTypeName = bookingsSelectors.selectAppointmentName(state);
  const appointmentTypeId = draftAppointmentTypeId || bookingAppointmentTypeId;

  return {
    appointmentTypeName: draftAppointmentTypeName || bookingAppointmentTypeName,
    headlineTitle: envConfigSelectors.selectHeadlineTitle(appointmentTypeId)(state),
  };
};

const mapDispatchToProps = {
  dispatchSetHeadlineTitle: setHeadlineTitle,
};

export const ConnectedWithHeadlineTitle = (headlineTitle) => (Component) =>
  connect(mapStateToProps, mapDispatchToProps)(withHeadlineTitle(headlineTitle)(Component));
